// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/views/Carousel';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import styles from './OutfitCarousel.style';

import { getIconPath, getViewportInfo } from '../../../../../utils';
import theme from '../../../../../../styles/themes/TCP';

const { breakpoints } = theme;
/**
 * @class OutfitCarousel - will display Complete The Look content

 */
class OutfitCarousel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasMounted: false,
    };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  /** This method is to add protocol to image url
   * since image is coming from unbox without protocol
   * and it breaks on local without protocol
   */
  getUrlWithHttp = (url) => url && url.replace(/(^\/\/)/, 'https:$1');

  handleOutfitClick = (items) => {
    const { onQuickViewOpenClick } = this.props;
    const productIds = items?.map((product) => ({
      colorProductId: product.remoteId,
      fromPage: 'bag',
      isOutfitsOnBag: true,
    }));
    onQuickViewOpenClick(productIds);
  };

  /**
   * This function is being called to render carousel items.
   * @param {object} item image object for the carousel
   * @param {integer} index Index for the carousel item
   */

  getSlideItem = (item, index) => {
    const { id, largeImageUrl, items } = item;

    return (
      <div key={`${index.toString()}_${id}`}>
        <div>
          <div className="outfit-image-wrapper">
            <Image
              alt={id}
              onClick={() => this.handleOutfitClick(items)}
              src={this.getUrlWithHttp(largeImageUrl)}
            />
          </div>
        </div>
      </div>
    );
  };

  renderItemList = (showCarousel, showSkeleton, CAROUSEL_OPTIONS, IconPath, bagOutfitProducts) => {
    const { hasMounted } = this.state;

    if (!showCarousel || !hasMounted) {
      return null;
    }

    const { isMobile } = getViewportInfo();
    if (isMobile) {
      return (
        <div className="smooth-scroll-list">
          {bagOutfitProducts.map((item, index) => (
            <div className="smooth-scroll-list-item slick-slide" key={item.id}>
              <div>{this.getSlideItem(item, index)}</div>
            </div>
          ))}
        </div>
      );
    }
    return (
      <Carousel
        options={CAROUSEL_OPTIONS}
        carouselConfig={{
          autoplay: false,
          customArrowLeft: IconPath,
          customArrowRight: IconPath,
        }}
      >
        {bagOutfitProducts.map((item, index) => this.getSlideItem(item, index))}
      </Carousel>
    );
  };

  render() {
    const { bagOutfitProducts = [], className } = this.props;
    const showCarousel = bagOutfitProducts.length > 0;
    const showSkeleton = true;
    const IconPath = getIconPath('icon-carrot-grey-large');
    const slidesMobile = bagOutfitProducts.length > 1 ? 1.5 : 1;
    const CAROUSEL_OPTIONS = {
      autoplay: false,
      arrows: true,
      centerMode: false,
      centerPadding: '0px',
      fade: false,
      speed: 200,
      swipeToSlide: true,
      swipe: true,
      infinite: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: parseInt(breakpoints.medium, 10) - 1,
          settings: {
            slidesToShow: slidesMobile,
            slidesToScroll: 1,
            arrows: false,
            swipeToSlide: true,
            infinite: false,
            centerMode: false,
            centerPadding: '30px',
          },
        },
        {
          breakpoint: parseInt(breakpoints.large, 10) - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '197px',
            arrows: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '197px',
            arrows: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 1195,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '197px',
            arrows: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    };

    return (
      <Grid className={className}>
        <Row className="complete-look-container" fullBleed={{ small: true, medium: true }}>
          <Col
            className="completeLook_carousel-wrapper"
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            {this.renderItemList(
              showCarousel,
              showSkeleton,
              CAROUSEL_OPTIONS,
              IconPath,
              bagOutfitProducts
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

OutfitCarousel.propTypes = {
  bagOutfitProducts: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
  onQuickViewOpenClick: PropTypes.func,
};

OutfitCarousel.defaultProps = {
  bagOutfitProducts: [],
  className: '',
  onQuickViewOpenClick: () => {},
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
  };
};

const styledCompleteTheLook = withStyles(connect(null, mapDispatchToProps)(OutfitCarousel), styles);

export default styledCompleteTheLook;

export { OutfitCarousel as OutfitCarouselVanilla };
